











import { vxm } from '../store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { OtpValidationToken } from '../models/userdata/otptoken';
import { AppUserOtpInfo } from '../models/userdata/appuserotpinfo';
import OtpVerification from './OtpVerification.vue';
import { config } from '@vue/test-utils';
import router from '../router';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import axios from 'axios';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'Verfication',
  components: {
    OtpVerification,
  },
})
export default class Verfication extends Vue {
  private otpToken: OtpValidationToken = new OtpValidationToken();
  private appUserOtpInfo: AppUserOtpInfo = new AppUserOtpInfo();
  private phoneNumberFromApi: String = '';
  private displayComponent = false;

  $wlToastr: any;
  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  get phoneNumber(): string {
    return vxm.users.myUserProfile.phoneNum;
  }
  continueOTP() {
    const vm = this;
    this.otpToken.userIdStr = vxm.users.myUserProfile.email;
    this.otpToken.failureCount = '0';
    this.otpToken.failedAttemptCount = 0;
    if (!this.otpToken.userIdStr) {
      this.otpToken.userIdStr = this.appUserOtpInfo.email;
    }
    this.otpToken.companyCode = vxm.jobs.BrandingInfo.companycode;
    const respPromise: any = vxm.users.anonAppValidateOTP(vm.otpToken);
    Promise.all([respPromise]).then((values) => {
      if (values[0].status === 'success') {
        vm.$wlToastr(
          'success',
          vm.$t('verfication.otp.success'),
          vm.$t('verification.toast.title'),
        );
        if (vm.appUserOtpInfo.phoneVerification) {
          const appurl =
            '/atsuser/otpVerification?success=true&mobile=' + this.phoneNumber;
          (<any>window).location = appurl;
          // axios.get(appurl);
        } else if (vm.appUserOtpInfo.sessionToken) {
          const appurl =
            '/atsuser/regSuccess?success=true&sessionToken=' +
            vm.appUserOtpInfo.sessionToken;
          (<any>window).location = appurl;
          // axios.get(appurl);
        } else if (vm.appUserOtpInfo.jobPostingId) {
          const appurl =
            '/atsuser/jobDetails?jobPostingId=' +
            vm.appUserOtpInfo.jobPostingId +
            '&referralCode=' +
            vm.appUserOtpInfo.referralCode;
          (<any>window).location = appurl;
        }
      } else {
        const errorMessage = values[0].error;
        vm.$wlToastr('error', errorMessage, vm.$t('verification.toast.title'));
      }
    });
  }

  continueEventHandler(otpTokenData) {
    console.log('continue');
    this.otpToken = otpTokenData;
    if (!this.otpToken.otp) {
      this.$wlToastr(
        'error',
        this.$t('verification.otp.validation.message'),
        this.$t('verification.toast.title'),
      );
    } else if (this.otpToken.otp.length < 5) {
      this.$wlToastr(
        'error',
        this.$t('verification.otp.validation.message'),
        this.$t('verification.toast.title'),
      );
    } else {
      this.continueOTP();
    }
  }
  skipEventHandler() {
    console.log('skip');
    const vm = this;
    if (vm.appUserOtpInfo.phoneVerification) {
      const appurl = '/atsuser/otpVerification?success=true';
      (<any>window).location = appurl;
      // axios.get(appurl);
    } else if (vm.appUserOtpInfo.userDeviceToken) {
      const appurl =
        '/atsuser/regSuccess?success=true&sessionToken=' +
        vm.appUserOtpInfo.sessionToken;
      (<any>window).location = appurl;
      // axios.get(appurl);
    }
  }
  resendEventHandler() {
    console.log('resend');
    const vm = this;
    const respPromise: any = vxm.users.resendOTP(vm.appUserOtpInfo.email);
    Promise.all([respPromise]).then((values) => {
      if (values[0].status === 'success') {
        vm.$wlToastr('info', vm.$t('resent-otp-success-msg'), vm.$t('verification.toast.title'));
      } else {
        const errorMessage = values[0].error;
        vm.$wlToastr('error', errorMessage, vm.$t('verification.toast.title'));
      }
    });
  }
  mounted() {
    // for webview in app.
    vxm.utility.setAppWebView(true);
    this.displayComponent = false;
    const vm = this;
    const userDeviceToken = vm.$route.query.userDeviceToken + '';
    const email = vm.$route.query.userid + '';
    const phoneVerification = vm.$route.query.phoneVerification + '';
    const sessionToken = vm.$route.query.sessionToken + '';
    const jobPostingId = vm.$route.query.jobPostingId + '';
    const referralCode = vm.$route.query.referralCode + '';

    vm.appUserOtpInfo.userDeviceToken =
      userDeviceToken !== 'undefined' ? userDeviceToken : '';
    vm.appUserOtpInfo.email = email !== 'undefined' ? email : '';
    vm.appUserOtpInfo.phoneVerification =
      phoneVerification !== 'undefined' ? phoneVerification : '';
    vm.appUserOtpInfo.sessionToken =
      sessionToken !== 'undefined' ? sessionToken : '';
    vm.appUserOtpInfo.jobPostingId =
      jobPostingId !== 'undefined' ? jobPostingId : '';
    vm.appUserOtpInfo.referralCode =
      referralCode !== 'undefined' ? referralCode : '';
    vxm.users.setUserDeviceAppTkn('sample');
    const respPromise: any = vxm.users.initAppUserOtpInfo(vm.appUserOtpInfo);
    Promise.all([respPromise]).then((values) => {
      if (values[0].status === 200) {
        let resp = new AppUserOtpInfo();
        resp = values[0].data;
        vm.appUserOtpInfo.userDeviceToken = resp.userDeviceToken;
        vm.appUserOtpInfo.email = resp.email;
        vm.appUserOtpInfo.phoneVerification = resp.phoneVerification;
        vm.appUserOtpInfo.sessionToken = resp.sessionToken;
        vm.phoneNumberFromApi = resp.phoneNumber;
        if (
          vxm.configs.getGlobalConfigValue('STAGES_TO_SKIP_OTP_VERIFICATION') &&
          vxm.configs.getGlobalConfigValue('STAGES_TO_SKIP_OTP_VERIFICATION').includes('1')
        ) {
          this.skipEventHandler();
          return;
        }
      }
      this.displayComponent = true;
    });
  }
}
